@if (data.transaction.extendedData; as data) {
  <div class="flex flex-col gap-4 p-2 text-xs opacity-70">
    <table class="w-full text-left">
      <thead>
        <tr class="border-b border-white/20">
          <th class="pb-1 font-medium">Item</th>
          <th class="pb-1 text-right font-medium">Claimed</th>
          <th class="pb-1 text-right font-medium">Paid</th>
          <th class="pb-1 text-right font-medium">Approved</th>
        </tr>
      </thead>
      <tbody>
        @for (item of data.items; track item.serviceCode.uid) {
          <tr>
            <td class="py-1">
              {{ item.quantity }} x {{ item.serviceCode.description }}
            </td>
            <td class="py-1 text-right">
              {{ item.quantity * item.serviceCode.amount | currency }}
            </td>
            <td class="py-1 text-right font-medium">
              @if (data.amountPayable) {
                {{ item.amountPayable | currency }}
              } @else {
                <span>---</span>
              }
            </td>
            <td class="py-1 text-right font-medium">
              @if (item.approved !== undefined) {
                @if (item.approved) {
                  <span class="text-success-400">Yes</span>
                } @else {
                  <span class="text-warn-400">No</span>
                }
              } @else {
                <span>---</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div
      class="flex flex-col items-end gap-1 self-end"
      [ngClass]="{
        'border-t border-white/20 pt-2': !!data.amountPayable
      }"
    >
      <div class="flex w-48 justify-between">
        <span>Amount Claimed:</span>
        <strong>{{ data.amountClaimed | currency }}</strong>
      </div>

      <div class="flex w-48 justify-between">
        <span>Amount Paid:</span>
        @if (data.amountPayable) {
          <strong>{{ data.amountPayable | currency }}</strong>
        } @else {
          <strong>---</strong>
        }
      </div>
    </div>
  </div>
}
